import axios from 'axios';
import { getDatadogLogger } from '@storebrand-digital/common-datadog';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type Document from '../../Document';

export async function fetchCategories() {
  return axios
    .get('/customer/document/archive/documents/categories')
    .then(({ data }) => data.payload)
    .catch((e) => {
      getDatadogLogger().error('Failed to fetch categories', {}, e);
    });
}

export default function useCategories() {
  return useQuery<Document.Categories[]>({
    queryKey: ['documents', 'categories'],
    queryFn: fetchCategories,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 1000 * 60 * 60,
  });
}
